<template>
  <section v-if="data" v-loading.fullscreen.lock="loading">
    <div class="term0">
      <div class="term0-content">
        <el-table
          ref="table"
          :header-cell-style="{
            background: '#fafafa',
            'text-align': 'center',
          }"
          :data="data"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column label="代码" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column width="320" prop="name" label="指标名称">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
              <el-tooltip
                v-if="scope.row.desc && scope.row.desc != ' '"
                effect="light"
                placement="left"
              >
                <div slot="content">
                  {{ scope.row.desc }}
                </div>
                <svg
                  t="1647934656452"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="3085"
                  width="16"
                  height="16"
                  @click="handleOpen(scope.row.desc)"
                >
                  <path
                    d="M512 149.333333A362.666667 362.666667 0 1 1 149.333333 512 363.093333 363.093333 0 0 1 512 149.333333M512 85.333333a426.666667 426.666667 0 1 0 426.666667 426.666667A426.666667 426.666667 0 0 0 512 85.333333z"
                    fill="#2f82ff"
                    p-id="3086"
                  />
                  <path
                    d="M469.333333 672a31.573333 31.573333 0 0 1-22.613333-9.386667l-128-128a32 32 0 0 1 45.226667-45.226666L469.333333 594.773333l213.333334-213.333333A32 32 0 0 1 725.333333 426.666667l-234.666666 234.666666a31.573333 31.573333 0 0 1-21.333334 10.666667z"
                    fill="#2f82ff"
                    p-id="3087"
                  />
                </svg>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="90">
            <template slot-scope="scope">
              <span class="text-center">{{ scope.row.uom }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value1" label="数值">
            <template slot-scope="scope" inline-template>
              <section v-if="scope.row.code == 11">
                <span class="text-center">{{ school_name }}</span>
              </section>
              <section v-else-if="scope.row.code == 111 ">
                <span class="text-center">{{ current_student ? current_student : scope.row.value1 }}</span>
              </section>
              <section v-else-if="scope.row.code == 112">
                <span class="text-center">{{ class_num ? class_num : scope.row.value1 }}</span>
              </section>
              <section v-else-if="scope.row.code == 113">
                <span class="text-center">{{ teachers ? teachers : scope.row.value1 }}</span>
              </section>
              <section v-else>
                <el-select
                  v-if="scope.row.equipstandardopt.optional"
                  v-model="scope.row.value1"
                  disabled
                  placeholder="请选择"
                  @change="
                    handleValue(scope.row.value1, scope.$index, scope.row)
                  "
                >
                  <el-option
                    v-for="item in scope.row.equipstandardopt.optional"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  />
                </el-select>
                <el-input
                  v-else
                  v-model="scope.row.value1"
                  placeholder=""
                  disabled
                  @input="scope.row.code == 11104
                    ? handleNumber1(scope.row.value1)
                    : handleNumber(scope.row.value1)"
                  @change="
                    handleValue(
                      scope.row.value1,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "
                  @focus="
                    handleValue(
                      scope.row.value1,
                      scope.$index,
                      scope.row,
                      scope
                    )
                  "

                />
              </section>
            </template>
          </el-table-column>
          <el-table-column prop="logic" label="取值逻辑">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.logic"
                effect="light"
                placement="top">
                <div slot="content">
                  {{ scope.row.logic }}
                </div>
                <span class="logic" @click="handleOpen(scope.row.logic)">{{
                  scope.row.logic
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </section>
</template>
<script>
import mock from '@/utils/mock'
import api from '@/api/app'
export default {
  name: 'ComTerm10',
  components: {},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      phone: '',
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      t: null,
      school_name: null,
      form: [],
      jsonForm: {},
      current_student: null,
      class_num: null,
      teachers: null,
      pushArr: true
    }
  },
  computed: {},
  watch: {},
  created() {
    var userInfo = localStorage.getItem('user')
    userInfo = JSON.parse(userInfo)
    this.school_name = userInfo.school_name
  },
  mounted() {
    if (localStorage.getItem('form1')) {
      this.form = JSON.parse(localStorage.getItem('form1'))
    }
  },
  methods: {
    compare(attr) {
      return function(a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    arrayLookup(data, key, value, targetKey) {
      var targetValue = ''

      for (var i = 0; i < data.length; i++) {
        if (data[i][key] == value) {
          targetValue = data[i][targetKey]
          break
        }
      }
      return targetValue
    },
    handleValue(x, y, z, a) {
      var isExit = false
      var obj = {}
      obj.code = z.code
      obj.id = z.id
      obj.name = z.name
      obj.desc = z.desc
      obj.uom = z.uom
      obj.equipstandardopt = z.equipstandardopt
      obj.logic = z.logic
      obj.value1 = z.value1
      obj.value2 = null
      obj.value3 = null
      obj.value4 = null
      obj.value5 = null
      obj.value6 = null

      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].id == z.id) {
          this.form[i].value1 = z.value1
          isExit = true
          break
        }
      }
      if (!isExit) {
        this.form.push(obj)
      }
      if (z.code == 11301) {
        localStorage.setItem('11301', z.value1)
      }
      if (z.code == 19) {
        localStorage.setItem('19', z.value1)
      }

      var a = this.handleValueModle(
        11101,
        11102,
        11103,
        0,
        this.current_student,
        111,
        11,
        '1.11 在校学生数',
        '',
        '人',
        {
          code: 111,
          hisIdx: [''],
          id: 11,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [false],
          year: 2022
        },
        '11101+11102+11103'
      )
      this.current_student = a
      var b = this.handleValueModle(
        11201,
        11202,
        11203,
        0,
        this.class_num,
        112,
        15,
        '1.12 班级数',
        '',
        '个',
        {
          code: 112,
          hisIdx: [''],
          id: 15,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [false],
          year: 2022
        },
        '11201+11202+11203'
      )
      this.class_num = b
      var c = this.handleValueModle(
        11301,
        11302,
        11303,
        11304,
        this.teachers,
        113,
        18,
        '1.13 教职工数',
        '',
        '人 ',
        {
          code: 113,
          hisIdx: [''],
          id: 18,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [false],
          year: 2022
        },
        '11301+11302+11303+11304'
      )
      this.teachers = c
      var d = this.handleValueModle(0, 0, 0, 0, this.school_name, 11, 1)
      if (this.form.length == this.data.length) {
        this.form.sort(this.compare('id'))
        this.toJson()
      }
    },
    handleValueModle(
      code1,
      code2,
      code3,
      code4,
      value,
      code,
      id,
      name,
      desc,
      uom,
      equipstandardopt,
      logic
    ) {
      var isExit = false
      var pupil = this.arrayLookup(this.form, 'code', code1, 'value1')
      var junior = this.arrayLookup(this.form, 'code', code2, 'value1')
      var heigh = this.arrayLookup(this.form, 'code', code3, 'value1')
      var others = this.arrayLookup(this.form, 'code', code4, 'value1')
      value = Number(pupil) + Number(junior) + Number(heigh) + Number(others)
      if (code == 111) {
        localStorage.setItem('111', value)
      } else if (code == 11) {
        value = this.school_name
        name = '1.1 学校名称'
        desc = '学校注册系统时的名称（公章上的全称）'
        uom = ''
        logic = ''
        equipstandardopt = {
          code: 11,
          hisIdx: [''],
          id: 1,
          names: ['数值'],
          optional: null,
          readOnly: [true],
          viewOnly: [false],
          year: 2022
        }
      }
      if (value) {
        const obj1 = {}
        obj1.code = code
        obj1.id = id
        obj1.name = name
        obj1.desc = desc
        obj1.uom = uom
        obj1.equipstandardopt = equipstandardopt
        obj1.logic = logic
        obj1.value1 = value
        obj1.value2 = null
        obj1.value3 = null
        obj1.value4 = null
        obj1.value5 = null
        obj1.value6 = null
        for (var i = 0; i < this.form.length; i++) {
          if (this.form[i].id == id) {
            this.form[i].value1 = value
            isExit = true
            break
          }
        }
        if (!isExit) {
          this.form.push(obj1)
        }
      }
      return value
    },
    toJson() {
      // for(let i of this.form){
      for (let i = 0; i < this.form.length; i++) {
        // let id = i.id
        // let code = i.code
        // let value1 = i.value1
        const id = this.form[i].id
        const code = this.form[i].code
        const name = this.form[i].name
        const desc = this.form[i].desc
        const uom = this.form[i].uom
        const equipstandardopt = this.form[i].equipstandardopt
        const logic = this.form[i].logic
        const value1 = this.form[i].value1
        const value2 = null
        const value3 = null
        const value4 = null
        const value5 = null
        const value6 = null
        this.jsonForm[id] = {
          code,
          name,
          desc,
          uom,
          equipstandardopt,
          logic,
          value1,
          value2,
          value3,
          value4,
          value5,
          value6
        }
      }
    },
    handleName(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[\u4e00-\u9fa5]|[a-zA-Z]+$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入中英文')
        }
      }, 800)
    },
    handleNumber1(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      var x = localStorage.getItem('111')
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入数字')
        } else {
          if (v > x) {
            this.$message.error(`输入数值不得大于${x}`)
            // this.pushArr = false
          }
        }
      }, 800)
    },
    handleNumber(v) {
      if (this.t != null) {
        clearTimeout(this.t)
      }
      this.t = setTimeout(() => {
        var reg = new RegExp('^[0-9]*$')
        if (!reg.test(v)) {
          this.$message.error('仅支持输入数字')
        }
      }, 800)
    },
    handlePre() {
      this.$emit('pre')
    },
    handleNext() {
      if (this.form.length == this.data.length) {
        this.$emit('next')
      } else {
        this.$message.error('请先填写当前页面，才可进行下一步')
      }
    },
    handleSave() {
      if (this.pushArr == true) {
        if (this.form.length < this.data.length) {
          this.$message.error('保存失败，请填写完整！')
        } else if (this.form.length == this.data.length) {
          this.toJson()
          const obj = {}
          obj.data = JSON.stringify(this.jsonForm)
          api.statistics.submit(obj).then((res) => {
            console.log(res)
            if (JSON.parse(localStorage.getItem('form1')) !== this.form) {
              this.$message.success('已保存成功！')
              localStorage.setItem('form1', JSON.stringify(this.form))
            } else if (JSON.parse(localStorage.getItem('form1')) == this.form) {
              this.$message.error('无修改数据！')
            } else {
              this.$message.success('已保存成功！')
              localStorage.setItem('form1', JSON.stringify(this.form))
            }
          })
        }
      } else {
        this.$message.error('保存失败，请仔细校验有取值逻辑的数值是否符合逻辑')
      }
    },
    handleClear() {
      this.$confirm('此操作将永久删除该表格数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          localStorage.removeItem('form1')
          this.class_num = null
          this.teachers = null
          this.current_student = null
          this.$emit('clear')
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    handleOpen(v) {
      this.$alert(v, '查看指标解释', {
        confirmButtonText: '关闭',
        callback: (action) => {}
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.term0 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    justify-content: space-between;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      border: 1px solid #d7d7d7;
      line-height: 34px;
      cursor: pointer;
      color: #8b8b8b;
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    .logic {
      cursor: pointer;
    }
  }
}
.term0-top-info /deep/ .el-input__inner {
  height: 34px;
}
.text-center {
  display: block;
  text-align: center;
}
</style>
